import React from 'react'
import { StyledSectionContainer, ModuleContentContainer, SecondaryTitle, TertiaryTitle } from '../shared/section'
import { colors } from '../../../utils/helpers/colors'
import LinkList from '../shared/LinkList'

const SubZonesModule = ({ zone: globalInfo, wording, zones }) => (
  <StyledSectionContainer backgroundColor={colors.white} data-testid="section-container-pp">
    <SecondaryTitle data-testid="secondary-title-pp">
      Affinez le lieu <b>de votre recherche immobili&egrave;re</b> {globalInfo.zoneDisplayNameWithParticle}
    </SecondaryTitle>
    <TertiaryTitle data-testid="tertiary-title-pp">Immobilier par {wording.plural}</TertiaryTitle>
    <ModuleContentContainer data-testid="module-content-pp">
      <LinkList links={zones} wording={wording} maxLinks={10} />
    </ModuleContentContainer>
  </StyledSectionContainer>
)

export default SubZonesModule
